// extracted by mini-css-extract-plugin
export default {"wrapper":"Sidebar_wrapper__l339x","itemsList":"Sidebar_itemsList__YvteG","selected":"Sidebar_selected__GYyJP"};